import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { eur, catLabel, gr } from "@/lib/api";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import BoatDetailsDialog from "@/components/BoatDetailsDialog";

export default function SlotHistoryDialog({ slot, open, onOpenChange }) {
  const navigate = useNavigate();
  const [finBoat, setFinBoat] = useState(null);

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-lg rounded-sm" data-testid="slot-history-dialog">
          <DialogHeader>
            <DialogTitle>
              Στοιχεία θέσης {slot?.label ? slot.label : `#${slot?.number}`} — {slot ? catLabel(slot.category_name) : ""}
            </DialogTitle>
          </DialogHeader>
          {slot && !slot.occupied && (
            <div className="py-6 text-center text-sm text-muted-foreground" data-testid="slot-history-empty">
              Η θέση είναι κενή. Καμία καταχώρηση.
            </div>
          )}
          {slot && slot.occupied && (() => {
            const b = slot.boat;
            const items = [
              { date: b.start_date, label: "Χρέωση παραμονής", amount: b.amount, type: "charge" },
              ...(b.charges || []).map((c) => ({ date: c.date, label: c.description, amount: c.amount, type: "charge" })),
              ...(b.payments || []).map((p) => ({ date: p.date, label: p.note || "Πληρωμή", amount: p.amount, type: "payment" })),
            ].sort((x, y) => ((x.date || "") < (y.date || "") ? -1 : 1));
            return (
              <div className="space-y-4">
                <div className="rounded-sm bg-secondary/50 p-3 text-sm">
                  <div className="font-semibold">{b.name} — {b.owner}</div>
                  {b.registry_no && <div className="text-xs text-muted-foreground">{b.registry_no}</div>}
                  <div className="mt-1 text-xs text-muted-foreground">Παραμονή: {gr(b.original_start_date || b.start_date)} → {gr(b.end_date)}{b.original_start_date && b.original_start_date !== b.start_date ? ` (τρέχουσα περίοδος από ${gr(b.start_date)})` : ""}</div>
                </div>
                <div className="flex gap-2">
                  <Button
                    className="flex-1 rounded-sm bg-[#10B981] hover:bg-[#0e9d70]"
                    data-testid="slot-financials-btn"
                    onClick={() => { setFinBoat(b); onOpenChange(false); }}
                  >
                    Οικονομικά στοιχεία
                  </Button>
                  <Button
                    variant="outline"
                    className="flex-1 rounded-sm"
                    data-testid="slot-edit-boat-btn"
                    onClick={() => { onOpenChange(false); navigate(`/boats?edit=${b.id}`); }}
                  >
                    Επεξεργασία στοιχείων
                  </Button>
                </div>
                <div className="space-y-1" data-testid="slot-history-list">
                  {items.map((it, i) => (
                    <div key={i} className="flex items-center justify-between border-b border-border py-1.5 text-sm last:border-0">
                      <div>
                        <span className="text-xs text-muted-foreground tabular-nums">{gr(it.date)}</span>
                        <span className="ml-2">{it.label}</span>
                      </div>
                      <span className={`font-medium tabular-nums ${it.type === "payment" ? "text-[#10B981]" : "text-[#234E7D]"}`}>
                        {it.type === "payment" ? "−" : "+"}{eur(it.amount)}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="space-y-1 border-t border-border pt-2 text-sm font-semibold">
                  <div className="flex justify-between">
                    <span>Χρέωση έως σήμερα</span>
                    <span className="tabular-nums">{eur(b.charged_to_date)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Υπόλοιπο στη λήξη</span>
                    <span className="tabular-nums">{eur(b.balance_to_end)}</span>
                  </div>
                </div>
              </div>
            );
          })()}
        </DialogContent>
      </Dialog>

      <BoatDetailsDialog
        boat={finBoat}
        open={!!finBoat}
        onOpenChange={(o) => !o && setFinBoat(null)}
      />
    </>
  );
}
